import { MeshBasicMaterial } from 'three';

export const CELL_MAT_NAMES = {
	frontales: 'frontalesMaterial',
	laterales :'lateralesMaterial',
	capillas: 'capillasMaterial',
	traversales: 'traversalesMaterial',
	selected: 'selectedMaterial'
};

export class SceneGroupMaterials {

	//FRONTALES MATERIAL
	static #frontalesMaterial = null;
	static get FrontalesMaterial() {
		if (this.#frontalesMaterial === null) {
			this.#frontalesMaterial = new MeshBasicMaterial( { color: 0x00aa00 } );
			this.#frontalesMaterial.name = CELL_MAT_NAMES.frontales;
		}
		
		return this.#frontalesMaterial;
	}

	//LATERALES MATERIAL
	static #lateralesMaterial = null;
	static get LateralesMaterial() {
		if (this.#lateralesMaterial === null) {
			this.#lateralesMaterial = new MeshBasicMaterial( { color: 0xaa0000 } );
			this.#lateralesMaterial.name = CELL_MAT_NAMES.laterales;
		}
		
		return this.#lateralesMaterial;
	}

	//CAPILLAS MATERIAL
	static #capillasMaterial = null;
	static get CapillasMaterial() {
		if (this.#capillasMaterial === null) {
			this.#capillasMaterial = new MeshBasicMaterial( { color: 0x00aaaa } );
			this.#capillasMaterial.name = CELL_MAT_NAMES.capillas;
		}
		
		return this.#capillasMaterial;
	}

	//TRAVERSALES MATERIAL
	static #traversalesMaterial = null;
	static get TraversalesMaterial() {
		if (this.#traversalesMaterial === null) {
			this.#traversalesMaterial = new MeshBasicMaterial( { color: 0x0000aa } );
			this.#traversalesMaterial.name = CELL_MAT_NAMES.traversales;
		}
		
		return this.#traversalesMaterial;
	}

	//SELECT MATERIAL
	static #selectedMaterial = null;
	static get SelectedMaterial() {
		if( this.#selectedMaterial === null ) {			
			this.#selectedMaterial = new MeshBasicMaterial( { color: 0xE8E337 } );
			this.#selectedMaterial.name = 'selectedMaterial';
		}
		return this.#selectedMaterial;
	}

	//light blue material for hovering
	static #hoverMaterial = null;
	static get HoverMaterial() {
		if( this.#hoverMaterial === null ) {
			this.#hoverMaterial = new MeshBasicMaterial( { color: 0x75BEFEC } );
			this.#hoverMaterial.name = 'hoverMaterial';
		}
		return this.#hoverMaterial;
	}

	// OUTLINE
	static #outlineMaterial = null;
	static get OutlineMaterial() {
		if( this.#outlineMaterial === null ) {
			this.#outlineMaterial = new MeshBasicMaterial( { color: 0x444444 } );
			this.#outlineMaterial.name = 'hoverMaterial';
		}
		return this.#outlineMaterial;

	}
}